import { DatepickerCustomizedProps } from "./types/datepickerProps";
import './datepicker.scss';
import "../../../helpers/validation/validation.scss";
import { AdditionalIcon } from "../additionalIcon/additionalIcon";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import pl from 'date-fns/locale/pl';
import { ReactComponent as addCircle } from '../../../icons/add_circle.svg';

const Datepicker = (props: DatepickerCustomizedProps) => {
  var iconStyle: React.CSSProperties = {
    display: props.displayIcon
  }

  return (
    <div onClick={props.onClickFilterComments} ref={props.inputRef} className={props.className ? props.className : "inputWrapper"}>
      <DatePicker 
        onChange={props.props?.onChange}
        dateFormat={props.props?.dateFormat}
        locale={pl}
        minDate={props.props?.minDate}
        maxDate={props.props?.maxDate}
        selected={props.props?.selected}
        shouldCloseOnSelect={props.props?.shouldCloseOnSelect}
        fixedHeight={props.props?.fixedHeight}
        placeholderText={props.props?.placeholderText}
        disabled={props.props?.disabled}
        showMonthYearPicker={props.props?.showMonthYearPicker}
        showYearPicker={props.props?.showYearPicker}
        className={`innerInput ${props.props?.className && props.props?.className !== undefined ? props.props?.className : ''}
          ${props.isMarkedForCommentFilter ? "markedForCommentFilter" : ""}`}
        todayButton={props.props?.hideTodayBtn ? undefined : 'Dzisiaj'}
        isClearable={props.props?.isClearable}
      />
      {AdditionalIcon(props.additionalIcon, iconStyle, props.classNameIcon)}
      {props.addCommentBtn?.visible && 
        <div className={`addCommentBtnWrapper addCommentBtnWrapperRegular ${props.isMarkedForCommentFilter ? "activeAddCommentBtn" : ""}`} 
        onClick={props.addCommentBtn.onClick}>
          {AdditionalIcon(addCircle)}
        </div>
      }
    </div>
  )
}

export default Datepicker;